<script>
module.exports = require( './CampaignInfo' );
</script>